import { getLocalStorage } from '../utils/storage';
import type { StoreApi} from 'zustand';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';

interface globalState {
  locale: 'zh_CN' | 'en_GB';
  loading: boolean;
  userId: string;
}

const initialState: globalState = {
  locale: (getLocalStorage('semi_locale') as 'zh_CN' | 'en_GB') || 'zh_CN',
  loading: false,
  userId: '',
};

const actions = (set: StoreApi<globalState>['setState'], get: StoreApi<globalState>['getState']) => {
  return {
    toogleLoading: (val: boolean) => set({ loading: val }),
    changeLocale: (val: 'zh_CN' | 'en_GB') => {
      if (val === 'zh_CN') set({ locale: 'zh_CN' });
      else set({ locale: 'en_GB' });
    },
    setAIUserId: (val: string) => set({ userId: val })
  };
};

export const useGlobal = create(combine(initialState, actions));
